export const layoutDebugEnabled = () =>
  typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('layoutDebug') === '1';

export const describeLayoutItem = (item) => ({
  id: item?.id,
  role: item?.role,
  sourceType: item?.sourceType,
  sourceTextEntryId: item?.sourceTextEntryId,
  pageLanguage: item?.pageLanguage,
  visible: item?.visibleOnCanvas !== false,
  position: item?.position,
  style: {
    presetFlow: item?.style?.presetFlow,
    linkedToPreset: item?.style?.linkedToPreset,
    presetId: item?.style?.presetId,
    presetName: item?.style?.presetName,
    fontSize: item?.style?.fontSize,
    fontFamily: item?.style?.fontFamily,
    fontFamilySecondary: item?.style?.fontFamilySecondary,
    fontStyle: item?.style?.fontStyle,
    fontStyleSecondary: item?.style?.fontStyleSecondary,
    padding: item?.style?.padding,
    alignment: item?.style?.alignment,
    showDivider: item?.style?.showDivider,
    positionMode: item?.style?.positionMode,
  },
  textLengths: Object.fromEntries(
    Object.entries(item?.texts || {}).map(([language, text]) => [language, String(text || '').length]),
  ),
});

export const logLayoutDebug = (event, details) => {
  if (!layoutDebugEnabled()) return;
  // Keep the payload in the message itself: Chrome's remote diagnostics API
  // captures console object arguments only as "Object", hiding the values
  // needed to compare Rebuild with Apply to page.
  console.info(`[Layout Debug] ${event} ${JSON.stringify(details)}`);
};

export const resolveBackgroundMode = (style = {}, config = {}) => {
  if (style.backgroundMode) return style.backgroundMode;
  if (config.backgroundMode) return config.backgroundMode;
  if (style.whiteBackground === false || config.whiteBackground === false) return 'none';
  return 'text';
};

export const getPresetVisibleSlotLanguages = (item, slotLanguages) => {
  if (!item.style?.presetFlow && item.schemaVersion !== 1) {
    return slotLanguages;
  }

  if (item.style?.textVisibility === 'primary') {
    return slotLanguages.slice(0, 1);
  }

  if (item.style?.textVisibility === 'secondary') {
    return slotLanguages.slice(1, 2);
  }

  return slotLanguages;
};
